import { gql } from '@apollo/client';

export const GET_SPACE_DOODLES_LEADERBOARD = gql`
  query GetSpaceDoodlesLeaderboard($data: GetSpaceDoodlesLeaderboardInput!) {
    getSpaceDoodlesLeaderboard(data: $data) {
      page
      pageSize
      totalPages
      totalItems
      totalPoints
      totalSpaceDoodles
      items {
        address
        ens
        username
        points
        position
        spaceDoodles {
          id
          image
          animationUrl
        }
      }
    }
  }
`;
